var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarbonRemovalCloud = function SvgCarbonRemovalCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDCDCD",
    d: "M27.266 9.399c0-3.544-2.9-6.42-6.476-6.42a6.49 6.49 0 0 0-4.542 1.848 4.94 4.94 0 0 0-4.489-2.86c-2.558 0-4.659 1.924-4.914 4.395h-.029C3.053 6.362 0 9.387 0 13.119s3.05 6.757 6.816 6.757a6.9 6.9 0 0 0 2.92-.655c.783 3.471 3.91 6.066 7.648 6.066 4.33 0 7.838-3.479 7.838-7.773 0-1.045-.21-2.041-.588-2.953 1.594-1.17 2.632-3.041 2.632-5.158z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    d: "M6.815 19.876c.961 0 1.87-.205 2.697-.559a.204.204 0 0 1 .28.137c.867 3.35 3.937 5.829 7.59 5.829 4.331 0 7.839-3.479 7.839-7.774-1.237 2.535-3.05 5.17-8.65 4.158-4.468-.807-6.439-4.483-6.901-5.487a.295.295 0 0 0-.377-.145c-4.595 1.852-6.934.193-9.152-1.543.636 3.074 3.386 5.388 6.674 5.388z",
    opacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C2",
    d: "M23.701 13.4c.373.421.933 1.16.933 1.16a6.45 6.45 0 0 0 2.145-2.72c-1.184 1.29-2.482 1.41-3.005 1.399a.096.096 0 0 0-.073.16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    d: "M3.5 5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    d: "M20.788 2.983a6.5 6.5 0 0 0-4.323 1.643.225.225 0 0 1-.352-.064 4.94 4.94 0 0 0-4.355-2.592c-2.49 0-4.55 1.828-4.895 4.207a.225.225 0 0 1-.215.192 6.81 6.81 0 0 0-6.334 4.72C.34 11.043 1.932 7.96 4.743 7.96c1.512 0 2.408.675 2.858 1.161.162.173.45.109.527-.116.313-.908 1.156-2.571 3.18-2.905 2.424-.401 3.548.98 3.986 1.788.11.2.393.2.506 0 .682-1.193 2.71-3.917 6.768-3.186 3.265.587 4.692 4.7 4.692 4.7 0-3.543-2.9-6.42-6.476-6.42z",
    opacity: 0.6
  })));
};
export default SvgCarbonRemovalCloud;